module.exports = __webpack_public_path__ + "images/0ca3839b323cbd3b35a656e911b99121.png";